var render = function render(){
  var _vm$summaryData;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between align-center"
  }, [_c('div', [_c('span', {
    staticClass: "pop-800"
  }, [_vm._v(_vm._s(_vm.summaryData.clientInfo.type) + "ov")]), _vm._v(" dlh "), _c('span', {
    staticClass: "pop-800"
  }, [_vm._v(_vm._s(_vm.summaryData.zostatok) + " EUR")]), _vm._v(" od "), _c('span', {
    staticClass: "pop-800"
  }, [_vm._v(_vm._s(_vm.translateBank(_vm.summaryData.banka)))])]), _c('div', [_c('img', {
    staticClass: "activate-button nav-link-icon filter-primary",
    "class": {
      'rotate': _vm.opened
    },
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f28_icons8-collapse-arrow.svg",
      "alt": ""
    },
    on: {
      "click": function click($event) {
        _vm.opened = !_vm.opened;
      }
    }
  })])]), _c('v-expand-transition', {
    staticClass: "summary-items-transition"
  }, [_vm.opened ? _c('div', {
    staticClass: "summary-items-wrapper"
  }, [_c('text-value-holder', {
    attrs: {
      "label": 'banka',
      "value": _vm.translateBank(_vm.summaryData.banka)
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'typ',
      "value": (_vm$summaryData = _vm.summaryData) === null || _vm$summaryData === void 0 ? void 0 : _vm$summaryData.typ
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'pôvodný objem',
      "value": _vm.summaryData.povodna_suma
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'zostatok',
      "value": _vm.summaryData.zostatok
    }
  }), _c('text-value-holder', {
    attrs: {
      "label": 'splátka',
      "value": _vm.summaryData.vyska_splatky
    }
  })], 1) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }